import { defineComponent } from 'vue';
export default defineComponent({
    name: 'VerificationStatusApproved',
    setup() {
        return {};
    },
});
